<template lang="pug">
section
  s-page-title(title='Менеджеры')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.sort_number }}
          td {{ props.item.full_name }}
          td {{ props.item.position }}
          td 
            div() {{ props.item.phone_formated }}
            div() {{ props.item.alt_phone }}

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='development/managers'
            )
  s-sorting-list(v-model='sorting' @sort-success='fetch')            
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Сорт',
        align: 'left',
        value: 'sort_number',
        width: '0%',
        sortable: true
      },
      {
        text: 'Имя',
        align: 'left',
        sortable: true,
        value: 'full_name'
      },
      {
        text: 'Должность',
        align: 'left',
        value: 'position',
        width: '0%',
        sortable: true
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone_formated',
        width: '0%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'development/managers',
      itemValue: 'id',
      itemText: 'full_name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter({
        ...pagination,  
        rowsPerPage: -1
      })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Development.Managers.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('development/managers', ['fetchList', 'destroy']),
    ...mapMutations('development/managers', ['setDataFilter'])
  },

  computed: {
    ...mapState('development/managers', ['total', 'dataFilter']),
    ...mapGetters('development/managers', ['list', 'isLoading']),
  }
}
</script>
